import React, { useEffect, useRef, useState } from 'react';
import { IconType } from 'react-icons/lib';

function useDynamicReactIcon(icon: string) {
  const iconRef = useRef<IconType>();
  const [, reRender] = useState({});

  useEffect(() => {
    import('react-icons/bs').then((reactIcons) => {
      const reactIcon = icon ? (reactIcons[icon] as IconType) : null;
      if (reactIcon) {
        iconRef.current = reactIcon;
      } else if (icon) {
        // Render placeholder when no icon is found
        iconRef.current = (() => (
          <span
            className="d-flex flex-column align-items-center ml-5"
            aria-label="nonExisitngIcon"
          >
            &#9888;
          </span>
        )) as unknown as IconType;
      }
      reRender({});
    });
  }, [icon]);
  return iconRef.current;
}

export default useDynamicReactIcon;
